import React from "react";

export function GameRowPlayer({game}) {
  const player_1 = game.player_1?.short_name ? game.player_1.short_name.split('/') : []
  const player_2 = game.player_2?.short_name ? game.player_2.short_name.split('/') : []
  const len = Math.max(player_1.length, player_2.length)

  return (
    <div className="tournament-games-row__player">
      {len > 0 ? (
        <>
          <div className="tournament-games-row__player-pair">
            {player_1.length ? player_1.map((name, i) => (
              <div key={i} className="tournament-games-row__player-name">{name}</div>
            )) : (
              <div className='tournament-games-row__player-placeholder'>
                {gettext('Ожидается...')}
              </div>
            )}
          </div>
          {len > 1 && <div className="tournament-games-row__player-hr"></div>}
          <div className="tournament-games-row__player-pair">
            {player_2.length ? player_2.map((name, i) => (
              <div key={i} className="tournament-games-row__player-name">{name}</div>
            )) : (
              <div className='tournament-games-row__player-placeholder'>
                {gettext('Ожидается...')}
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="tournament-games-row__player-pair">
          <div className='tournament-games-row__player-placeholder'>
            {gettext('Ожидается...')}
          </div>
        </div>
      )}
    </div>
  )
}